import React from 'react';
import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';
import Button from './Button';

import * as CSS from './OverlapIsAdultConfirmation.module.css';

const STORAGE_KEY = 'overlap-adult-confirmed';

function OverlapIsAdultConfirmation() {
  const [isOpen, setIsOpen] = React.useState(true);

  function onYes(e) {
    e.stopPropagation();
    e.preventDefault();

    setIsOpen(false);

    window.localStorage.setItem(STORAGE_KEY, '1');
  }

  function onNo(e) {
    e.stopPropagation();
    e.preventDefault();
    window.document.location.href = 'https://www.google.com/'; // Redirect to Google if not 18
  }

  if (window.localStorage.getItem(STORAGE_KEY) === '1') {
    return null;
  }

  if (!isOpen) return null;

  return (
    <div
      className={CSS.modal}
    >
      <div
        className={CSS.content}
      >
        <div className={CSS.title}>
          <FormattedMessage id="overlay18YearsTitle" />
        </div>

        <div className={CSS.buttons}>
          <div>
            <Button to="#" type="filled" className={CSS.button} onClick={onYes}>
              <FormattedMessage id="yes" />
            </Button>

            <div className={CSS.buttonText}>
              <FormattedMessage id="overlay18YearsYesText" />
            </div>
          </div>
          <div>
            <Button to="#" type="link" className={classNames(CSS.button, CSS.buttonNo)} onClick={onNo}>
              <FormattedMessage id="no" />
            </Button>

            <div className={CSS.buttonText}>
              <FormattedMessage id="overlay18YearsNoText" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default OverlapIsAdultConfirmation;
